export default __webpack_public_path__ + "static/media/afrobeats-text.f05de677.png";